const imagePath = main__js_vars.themeRoot + '/library/images/';

const images = [
    imagePath + 'loading-placeholder-1.jpg',
    imagePath + 'loading-placeholder-2.jpg',
    imagePath + 'loading-placeholder-3.jpg',
    imagePath + 'loading-placeholder-4.jpg'
];

let i = 1;
let imageInterval;

const loadingScreen = () => {
    if ( $('.c-loading-screen').length ) {   
        imageInterval = setInterval(loadingScreenImageUpdate, 600);
    } else {
        removeLoadingScreen();
    }
};

const loadingScreenImageUpdate = (image) => { 
    $('.c-loading-screen__image').attr('src', images[i]);
    
    i++;

    if ( i === images.length ) {
        clearInterval(imageInterval);
        removeLoadingScreen();
    }
}

const removeLoadingScreen = () => {
    const widthScale = window.innerWidth / 292;
    const heightScale = window.innerHeight / 361;
    const scale = widthScale > heightScale ? 1 + widthScale : 1 + heightScale;

    let tl = gsap.timeline({
        delay: 0.6,
        onStart: () => window.scrollTo(0, 0),
        onComplete: () => {
            $('body').removeClass('loading');
            $('.c-loading-screen').addClass('loaded');
            revealHeroContent();
        }
    });
    tl.to('.c-loading-screen__arch .e-svg .e-svg__fill', { fill: '#430000', duration: 0.1 });
    tl.to('.c-loading-screen__img-container', { opacity: 0, duration: 0.2 });
    tl.addLabel('showContent');
    tl.to('.c-loading-screen__arch', { scaleX: scale, scaleY: scale, duration: 0.6 }, 'showContent');
    tl.to('.c-loading-screen', { opacity: 0, duration: 0.8 }, 'showContent');
    tl.to('.c-loading-screen__arch', { opacity: 0, duration: 0.3 }, '-=0.3');
};

const revealHeroContent = () => {
    ScrollTrigger.matchMedia({  
        // Wider and Taller Screen
        "(min-width: 992px) and (min-height: 700px)": function() {
            CustomEase.create('NavEase', '0.165, 0.84, 0.44, 1.00');
            CustomEase.create('headingEase', '0.165, 0.84, 0.44, 1.00');
            
            const section = document.querySelector('.hero-section');

            const headingLines = section.querySelectorAll('.js-split-text-line');
            const content = section.querySelectorAll('.hero-section__content');
            const sliderNav = section.querySelector('.c-slider-nav');
            const buttons = section.querySelectorAll('.hero-section__buttons');

            let tl = gsap.timeline();
            tl.addLabel('headerAnimations');
            tl.to('.js-header-anim-elem', { opacity: 1, duration: 0.5 });
            tl.to('.c-nav-items__item', { opacity: 1, ease: 'navEase', duration: 0.3 }, 'headerAnimations');
            tl.to('.c-nav-items__item', { y: 0, ease: 'navEase', duration: 0.8 }, 'headerAnimations');
            
            tl.addLabel('heroAnimations', '-=0.3');
            
            if ( headingLines.length ) {
                const headingDelay = 0.1;
                
                headingLines.forEach((line, i) => {
                    tl.to(line.querySelectorAll('span'), { opacity: 1, ease: 'headingEase', duration: 0.3 }, 'heroAnimations+=' + ((i + 1) * headingDelay));
                    tl.to(line.querySelectorAll('span'), { opacity: 1, y: 0, ease: 'headingEase', duration: 0.8 }, 'heroAnimations+=' + ((i + 1) * headingDelay));
                });
            }

            const contentAnimObj = { opacity: 1, y: 0, duration: 1 };
            
            if ( content ) {
                tl.to(content, contentAnimObj, 'heroAnimations');
            }
            if ( sliderNav ) {
                tl.to(sliderNav, contentAnimObj, 'heroAnimations');
            }
            if ( buttons ) {
                tl.to(buttons, contentAnimObj, 'heroAnimations');
            }
            tl.to('.hero-section__scroll', { opacity: 1, duration: 1 });
        }
    });     
}